export default __webpack_public_path__ + "static/media/K Srinivas.2148ff38.png";